// src/pages/Userpanel/ReferralPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ReferralPage = () => {
  const navigate = useNavigate();
  const [refCode, setRefCode] = useState("");
  const [totalRefer, setTotalRefer] = useState(0); // Total Refer
  const [referEarn, setReferEarn] = useState(0);   // Refer Earn

  useEffect(() => {
    const fetchReferralData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await fetch("https://api.earnmoney0.top/api/user/me", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) throw new Error("Failed to fetch user");

        const data = await res.json();
        setRefCode(data.referCode || "N/A");
        setTotalRefer(data.totalReferrals || 0); // <-- Backend থেকে আসা totalReferrals
        setReferEarn(0); // এখনও 0, চাইলে API থেকে কমিশন নিতে হবে
      } catch (err) {
        console.error(err);
        setRefCode("N/A");
      }
    };

    fetchReferralData();
  }, []);

  const referralLink = `${window.location.origin}/register?ref=${refCode}`;

  const copyText = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied successfully ✅");
  };

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <span style={styles.back} onClick={() => navigate(-1)}>←</span>
        <h3>Referral</h3>
      </div>

      {/* ===== Stats Cards ===== */}
      <div style={styles.statsContainer}>
        <div style={{ ...styles.statsCard, ...styles.cardGradient1 }}>
          <div style={styles.statsTitle}>Total Refer</div>
          <div style={styles.statsNumber}>{totalRefer}</div>
        </div>
        <div style={{ ...styles.statsCard, ...styles.cardGradient2 }}>
          <div style={styles.statsTitle}>Refer Earn</div>
          <div style={styles.statsNumber}>{referEarn}</div>
        </div>
      </div>

      {/* Referral Code Card */}
      <div style={styles.card}>
        <h4 style={styles.title}>🎁 আপনার রেফার কোড</h4>
        <div style={styles.codeBox}>
          <span style={styles.code}>{refCode || "Loading..."}</span>
          <button onClick={() => copyText(refCode)} style={styles.copyBtn}>
            Copy
          </button>
        </div>
        <p style={styles.info}>
          এই কোড ব্যবহার করে কেউ রেজিস্টার করলে আপনি বোনাস পাবেন 💰
        </p>
      </div>

      {/* Referral Link Card */}
      <div style={styles.card}>
        <h4 style={styles.title}>🔗 Referral Link</h4>
        <div style={styles.linkBox}>
          <input value={referralLink} readOnly style={styles.input} />
          <button onClick={() => copyText(referralLink)} style={styles.copyBtn}>
            Copy
          </button>
        </div>
      </div>

      {/* Info Section */}
      <div style={styles.note}>
        <div style={styles.noteItem}>
          💰 <span style={{ color: "#166534" }}>
            প্রতি সফল রেফারে আপনি কমিশন পাবেন
          </span>
          <b style={{ color: "#15803d", fontSize: 18 }}> ৳25+</b>
        </div>
        <div style={styles.noteItem}>
          🎯 এক ইউজার আপনার রেফার কোড ব্যবহার করে একাউন্ট তৈরি করলে এবং
          <b style={{ color: "#7c2d12" }}> ৩০০ টাকা ডিপোজিট</b> করলেই আপনি কমিশন পাবেন  
          <span style={{ color: "#9a3412" }}> (একবারই)</span>।  
          যত রেফার, তত ইনকাম 🎉
        </div>
        <div style={styles.noteItem}>
          📞 কমিশন মেইন ব্যালেন্সে নিতে এবং কমিশন ইনকাম জানতে অবশ্যই
          <b style={{ color: "#1e3a8a" }}> এডমিনের সাথে যোগাযোগ</b> করতে হবে।  
          এডমিন নিজে টাকা এড করে দিবে ✅
        </div>
      </div>
    </div>
  );
};

export default ReferralPage;

/* ---------------- STYLES ---------------- */
const styles = {
  page: {
    minHeight: "100vh",
    background: "#f2f2f2",
    padding: 15,
  },
  header: {
    background: "#7a0f7a",
    color: "#fff",
    padding: "15px",
    display: "flex",
    alignItems: "center",
    gap: 10,
    borderRadius: 8,
  },
  back: { fontSize: 22, cursor: "pointer" },

  /* Stats Cards */
  statsContainer: {
    display: "flex",
    gap: 15,
    marginTop: 15,
  },
  statsCard: {
    flex: 1,
    borderRadius: 14,
    padding: 20,
    textAlign: "center",
    color: "#fff",
    boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
    transition: "transform 0.3s, box-shadow 0.3s",
    cursor: "default",
  },
  cardGradient1: { background: "linear-gradient(135deg, #7c3aed, #9333ea)" },
  cardGradient2: { background: "linear-gradient(135deg, #16a34a, #4ade80)" },
  statsTitle: { fontSize: 14, fontWeight: 500, opacity: 0.9 },
  statsNumber: { fontSize: 28, fontWeight: 700, marginTop: 6 },

  /* Referral Card */
  card: {
    background: "#fff",
    padding: 15,
    borderRadius: 12,
    marginTop: 15,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  title: { marginBottom: 10, color: "#7a0f7a" },
  codeBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#f3e8ff",
    padding: 12,
    borderRadius: 10,
  },
  code: { fontSize: 18, fontWeight: 700, letterSpacing: 1 },
  copyBtn: {
    background: "#7a0f7a",
    color: "#fff",
    border: "none",
    padding: "6px 12px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 600,
  },
  info: { marginTop: 10, fontSize: 13, color: "#555" },
  linkBox: { display: "flex", gap: 8 },
  input: { flex: 1, border: "1px solid #ccc", borderRadius: 8, padding: 8, fontSize: 13 },

  note: {
    marginTop: 20,
    background: "linear-gradient(135deg, #e0f2fe, #f0f9ff)",
    padding: 14,
    borderRadius: 12,
    color: "#075985",
  },
  noteItem: {
    background: "#ffffff",
    padding: "12px 14px",
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 500,
    lineHeight: 1.6,
    marginBottom: 10,
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  },
};